import styled from '@emotion/styled'

export const Content = styled.div`
  color: #73738C;
  font-size: 0.875rem;
  text-align: center;
`
